import ClientPortalCasesRoutes from './ClientPortalCasesRoutes';

export default ClientPortalCasesRoutes;
